/**
 * Loading skeleton for EventDetail page
 * Shows animated placeholder while data is loading
 */
export default function LoadingSkeleton() {
  return (
    <div className="space-y-6 animate-pulse">
      <div className="h-6 w-16 bg-surface-50 rounded"></div>
      <div className="h-32 bg-surface-50 rounded-lg"></div>
      <div className="grid grid-cols-4 gap-4">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="h-20 bg-surface-50 rounded-lg"></div>
        ))}
      </div>
      <div className="grid grid-cols-2 gap-6">
        <div className="h-64 bg-surface-50 rounded-lg"></div>
        <div className="h-64 bg-surface-50 rounded-lg"></div>
      </div>
    </div>
  );
}
